export class Fee {
    percent: number
    cancellationFee: number
}



// WEBPACK FOOTER //
// ./src/types/Fee.ts